import { render, staticRenderFns } from "./roleDiv.vue?vue&type=template&id=b72838e8&scoped=true"
import script from "./roleDiv.vue?vue&type=script&lang=js"
export * from "./roleDiv.vue?vue&type=script&lang=js"
import style0 from "./roleDiv.vue?vue&type=style&index=0&id=b72838e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72838e8",
  null
  
)

export default component.exports